import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.homework.commentdetails;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    CHANGE_UNIT: `${uid}.changeUnit`,
    CACHE_COMMENTS: `${uid}.cacheComments`,
    SAVE_COMMENTS_ASYNC: `${uid}.saveCommentsAsync`,
    SAVE_COMMENTS_SUCCESS: `${uid}.saveCommentsSuccess`,
    SAVE_COMMENTS_FAILURE: `${uid}.saveCommentsFailure`,
    LOAD_NEXT: `${uid}.loadNext`,
    LOAD_NEXT_SUCCESS: `${uid}.loadNextSuccess`,
    LOAD_NEXT_FAILURE: `${uid}.loadNextFailure`,

};

export { ActionTypes };
